// The CI Signal Grid mark v2, inlined (no asset fetch, crisp at any size):
// a quiet grid of runs (dots), one luminous signal with a halo. Same geometry
// as public/logo.svg; colors track the theme via the brand tokens.
export default function Logo({ size = 18 }) {
  const cells = [
    [16, 16], [32, 16], [48, 16],
    [16, 32], [32, 32],
    [16, 48], [32, 48], [48, 48],
  ];
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label="CI Signal Grid"
      className="brand-mark"
    >
      <g className="brand-mark__cells">
        {cells.map(([cx, cy]) => <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="5.5" />)}
      </g>
      <circle className="brand-mark__halo" cx="48" cy="32" r="12" />
      <circle className="brand-mark__signal" cx="48" cy="32" r="7" />
    </svg>
  );
}
